import type { NodeData } from '@ipfabric/utils';

export const isNodeExpandable = (nodeData: NodeData): boolean =>
  nodeData.type === 'hostGroup' || nodeData.type === 'phoneGroup';
